// extracted by mini-css-extract-plugin
module.exports = {"price":"price_price__VD5u5","tax_message":"price_tax_message__0BAta"};